import { render } from "./TaskBoardView.vue?vue&type=template&id=419cb79c&scoped=true"
import script from "./TaskBoardView.vue?vue&type=script&lang=ts"
export * from "./TaskBoardView.vue?vue&type=script&lang=ts"

import "./TaskBoardView.vue?vue&type=style&index=0&id=419cb79c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-419cb79c"

export default script